// @flow
import React from "react";
import glamorous from "glamorous";
import cx from "classnames";
import * as consts from "~/src/common/consts";

type ResultTopBarProps = {
    direction?: $Keys<typeof consts.DIRECTION>,
    className? : string,
    children?: any,
};

const GResultTopBar = glamorous.div(({ direction }) => cx(
	"flex flex-nowrap items-center",
	"b--solid bc-window-border bw1 br-0 bt-0 bl-0 bb-1",
	{
		"flex-direction": `${direction === consts.DIRECTION.HORIZONTAL ? "row" : "column"}`,
	},
));

const ResultsTopBar = ({ direction, className, children }: ResultTopBarProps) => (
	<GResultTopBar direction={direction} className={className}>
		{children}
	</GResultTopBar>
);

export default ResultsTopBar;
